module.exports = __webpack_public_path__ + "img/code-tip.9a044baf.png";